import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "info__modal-wrapper" }
const _hoisted_2 = { class: "info__modal-head" }
const _hoisted_3 = { class: "info__modal-head-title" }
const _hoisted_4 = { class: "info__modal-scroll-container" }
const _hoisted_5 = { class: "info__modal-scroll-content" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "info__modal-overlay",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
      }, [
        _createElementVNode("div", {
          class: "info__modal",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.modalData.name), 1),
              _createVNode(_component_v_btn, {
                onClick: _ctx.closeModal,
                class: "info__modal-close-btn",
                icon: "mdi mdi-close",
                variant: "text",
                "aria-label": "Zamknij okno"
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "modal-desc",
                  innerHTML: _ctx.modalData.description
                }, null, 8, _hoisted_6)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}